import {FC} from 'react';
import block from 'bem-cn-lite';
import {Button, Icon, Radio, Sheet, Text} from '@gravity-ui/uikit';
import {Xmark} from '@gravity-ui/icons';
import {
    BRAND_SUGGESTION_SORT_PRESETS,
    BrandSuggestionSortOption,
    BrandSuggestionSortProperty,
    SortDirection
} from './sortBrandSuggestions';

import './BrandSuggestionsMobileSorting.scss';

const b = block('brand-suggestions-mobile-sorting');

interface BrandSuggestionsMobileSortingProps {
    isOpen: boolean;
    onClose: () => void;
    sortOptions: BrandSuggestionSortOption[];
    onSortChanged: (property: BrandSuggestionSortProperty, direction: SortDirection) => void;
}

export const BrandSuggestionsMobileSorting: FC<BrandSuggestionsMobileSortingProps> = ({
    isOpen,
    onClose,
    sortOptions,
    onSortChanged
}) => {
    const active = sortOptions.find((option) => option.isActive);

    function handleChange(property: BrandSuggestionSortProperty, direction: SortDirection) {
        onSortChanged(property, direction);
        onClose();
    }

    return (
        <div className={b()}>
            <Sheet visible={isOpen} onClose={onClose} hideTopBar>
                <div className={b('content')}>
                    <div className={b('header')}>
                        <Text variant="header-2">Сортировка</Text>
                        <Button view="normal" size="m" onClick={onClose}>
                            <Icon data={Xmark} />
                        </Button>
                    </div>

                    <div className={b('radio-list')}>
                        {BRAND_SUGGESTION_SORT_PRESETS.map((preset) => (
                            <Radio
                                key={preset.label}
                                value={preset.label}
                                content={preset.label}
                                size="l"
                                checked={
                                    active?.property === preset.property &&
                                    active.direction === preset.direction
                                }
                                onChange={() => handleChange(preset.property, preset.direction)}
                            />
                        ))}
                    </div>
                </div>
            </Sheet>
        </div>
    );
};
